import React from "react";
import {useFormContext} from "react-hook-form";
import {Link} from 'react-router-dom'

import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import CircularProgress from '@mui/material/CircularProgress';

import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/ro';

import * as CustomStyles from '../../styles/CustomStyles';
import CustomSelect from '../../custom/CustomSelectComponent'
import * as SelectTypes from '../../constants/CustomSelectTypes'
import * as ValidationMessages from '../../constants/ValidationMessages';
import * as DataPattern from '../../constants/DataPattern';
import * as DateHelper from '../../util/DateHelper';
import * as Const from '../../constants/SystemConstants';
import { getRsvtiOperatorSelectData } from "../../util/TypeConvertor";
import * as RestCall from '../../../utils/network/RestCalls';


const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file)
        fileReader.onload = () => {
          resolve(fileReader.result);
        }
        fileReader.onerror = (error) => {
          reject(error);
        }
      })        
}


const downloadCertificateDoc = async (documentKey) => {
    const fileName = documentKey.split('/')[4];

    return await RestCall.fetchAuthzCertUrl(documentKey)
        .then((response) => {
            window.open(response.authz_cert_url, '_blank').focus();
        })
        .catch(error => console.log(error));    
}


export const AuthorizationInternal = (props) => {
    console.log('AuthorizationInternal Component___');

    const { register, setValue, formState: { errors, defaultValues } } = useFormContext();

    const [dateCertificate, setDateCertificate] = React.useState(dayjs(`${defaultValues.lAuthorization.autorizatie.dateCertificate}`));
    const [dateMaturityCertificate, setDateMaturityCertificate] = React.useState(dayjs(`${defaultValues.lAuthorization.autorizatie.dateMaturity}`));

    const [selectedRsvtiOperatorId, setSelectedRsvtiOperatorId] = React.useState( defaultValues.lAuthorization?.autorizatie?.operatorRsvtiUname!=null ? defaultValues.lAuthorization.autorizatie.operatorRsvtiUname : '' );
    const rsvtiOperatorSelectData = getRsvtiOperatorSelectData(props.rsvtiOperators);

    const [isUploadingData, setIsUploadingData] = React.useState(false);

    const validateCertificateDate = (dataAuthorizationStr) => {
        if( DateHelper.isValidStringDateFmt(dataAuthorizationStr) ) {
            return true;
        }
        else {
            return 'Format data este invalid';
        }
    }

    const validatedateMaturityAutorizatie = (dateMaturityStr) => {
        if(dateMaturityStr){
            if( DateHelper.isValidStringDateFmt(dateMaturityStr) ) {
                const dateMaturity = DateHelper.getDateFromString(dateMaturityStr);
                if(dateMaturity < dateCertificate) {
                    return 'Data Scadenta este inainte de Data Adeverinta';
                }
                else if(dateMaturity < dayjs()) {
                    return 'Data Scadenta este in trecut';
                }
                else{
                    return true;
                }
            }
            else {
                return 'Format data este invalid';
            }    
        }
        else {
            return true;
        }
    }

    const uploadCertificate = async (docToUpload) => {
        const docBase64 = await convertFileToBase64(docToUpload)
        setIsUploadingData(true);
        await props.saveAuthzCert(docToUpload.name, 
                            docBase64,  
                            defaultValues.employerId, 
                            defaultValues.employeeId, 
                            defaultValues.lAuthorization.id);
        setIsUploadingData(false);
    }
    // use 'ro' locale globally
    dayjs.locale('ro');

    return(
        <React.Fragment>
            <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                {/*row*/}
                <Grid item xs={8}>
                    <CustomSelect 
                        disabled={!!defaultValues.lAuthorization.id}
                        // callback={setSelectedAuthorization}
                        selectId={'aaInternal'} 
                        selectType={SelectTypes.ANGAJAT_AUTORIZAT_INTERN} 
                        value={defaultValues.lAuthorization.autorizatie.authInternal} 
                        register={{...register('lAuthorization.autorizatie.authInternal', {required: ValidationMessages.REQUITED_MESSAGE})}}
                        error={!!errors?.lAuthorization?.autorizatie?.authInternal}
                        helperText={errors?.lAuthorization?.autorizatie?.authInternal ? errors.lAuthorization.autorizatie.authInternal.message : null}
                    />
                </Grid>
                <Grid item xs={4}>
                    <TextField variant="standard" size="small" label="Nota Deservent" fullWidth margin="dense" 
                        {...register("lAuthorization.autorizatie.authzInternalNote")} 
                    />
                </Grid>

                {/*row*/}
                <Grid item xs={8}>
                    <CustomSelect 
                        selectId={'servicedEquipmentType'} 
                        selectType={SelectTypes.INSTALATII_PERSONAL_AUXILIAR} 
                        value={defaultValues.lAuthorization.autorizatie.servicedEquipmentType} 
                        register={{...register('lAuthorization.autorizatie.servicedEquipmentType', {required: ValidationMessages.REQUITED_MESSAGE})}}
                        error={!!errors?.lAuthorization?.autorizatie?.servicedEquipmentType}
                        helperText={errors?.lAuthorization?.autorizatie?.servicedEquipmentType ? errors.lAuthorization.autorizatie?.servicedEquipmentType.message : null}
                    />   
                </Grid>
                <Grid item xs={4}>
                    <TextField variant="standard" size="small" label="Nota Instalatie" fullWidth margin="dense" 
                        {...register("lAuthorization.autorizatie.servicedEquipmentTypeNote")} 
                    />
                </Grid>

                {/*row*/}
                <Grid item xs={4}>
                    <TextField variant="standard" size="small" label="Nr. Adeverinta" fullWidth margin="dense" 
                        {...register("lAuthorization.autorizatie.certificateNo", {required: ValidationMessages.REQUITED_MESSAGE})} 
                        error={!!errors?.lAuthorization?.autorizatie?.certificateNo}
                        helperText={errors?.lAuthorization?.autorizatie?.certificateNo ? errors.lAuthorization.autorizatie.certificateNo.message : null}
                    />
                </Grid>
                <Grid item xs={4}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='ro'>
                        <DesktopDatePicker
                            label="Data Adeverinta"
                            inputFormat={DataPattern.DATE_FORMAT_RO}
                            format={DataPattern.DATE_FORMAT_RO}
                            value={dateCertificate}
                            onChange={(newValue) => {
                                if(newValue && newValue.isValid()) {
                                    setDateCertificate( newValue );
                                    setValue('lAuthorization.autorizatie.dateCertificate', newValue.toISOString());

                                    const maturityDate = newValue.add(Const.CERTIFICATE_EXPIRATION_YEARS, 'year');
                                    setDateMaturityCertificate(maturityDate);
                                    setValue('lAuthorization.autorizatie.dateMaturity', maturityDate.toISOString());        
                                }
                            }}
                            renderInput={(params) => 
                                <TextField {...params} variant="standard" 
                                    {...register('lAuthorization.autorizatie.dateCertificate', 
                                        {required: ValidationMessages.REQUITED_MESSAGE,
                                        validate: vd => validateCertificateDate(vd)}
                                    )}
                                    error={!!errors?.lAuthorization?.autorizatie?.dateCertificate}
                                    helperText={errors?.lAuthorization?.autorizatie?.dateCertificate ? errors.lAuthorization.autorizatie.dateCertificate.message : null}
                                />
                            }
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={4}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                            label="Data Scadenta Adeverinta"
                            inputFormat={DataPattern.DATE_FORMAT_RO}
                            value={dateMaturityCertificate}
                            onChange={(newValue) => {
                                setDateMaturityCertificate(newValue);
                                if(newValue && newValue.isValid()) {
                                    setValue('lAuthorization.autorizatie.dateMaturity', newValue.toISOString());
                                }
                            }}
                            renderInput={(params) => 
                                <TextField {...params} variant="standard" 
                                    {...register('lAuthorization.autorizatie.dateMaturity', 
                                        {required: ValidationMessages.REQUITED_MESSAGE, 
                                        validate: vd => validatedateMaturityAutorizatie(vd) }
                                    )}
                                    error={!!errors?.lAuthorization?.autorizatie?.dateMaturity}
                                    helperText={errors?.lAuthorization?.autorizatie?.dateMaturity ? errors.lAuthorization.autorizatie.dateMaturity.message : null}
                                />
                            }
                        />
                    </LocalizationProvider>
                </Grid>

                {/*row*/}
                <Grid item xs={4}>
                    <FormControl fullWidth size="small" margin="dense" variant="standard">
                        <InputLabel id={'rsvtiOperator-inputLabelId'} error={!!errors?.lEmployee?.employmentDetails?.employerId}>Operator RSVTI</InputLabel>
                        <Select
                            {...register('lAuthorization.autorizatie.operatorRsvtiUname', {required: ValidationMessages.REQUITED_MESSAGE})}
                            labelId={'rsvtiOp-selectLabelId'}
                            id={'rsvtiOperator'}
                            value={selectedRsvtiOperatorId}
                            onChange={(event) => {
                                setSelectedRsvtiOperatorId(event.target.value);
                            }}
                                label={'rsvtiOperator-label'}
                            error={!!errors?.lAuthorization?.autorizatie?.operatorRsvtiUname}
                            >
                            {
                                rsvtiOperatorSelectData.map((data) => <MenuItem dense value={data.id} key={data.id}> {data.name} </MenuItem>)
                            }
                        </Select>
                        <Typography sx={{ color: 'error.main', fontSize: 12 }}>{errors?.lAuthorization?.autorizatie?.operatorRsvtiUname ? errors.lAuthorization.autorizatie.operatorRsvtiUname.message : null}</Typography>
                    </FormControl>
                </Grid>
                <Grid item xs={8}>
                </Grid>

                {/*row*/}
                <Grid item xs={2}>
                    <CustomSelect 
                        selectId={'authzsStatus'} 
                        selectType={SelectTypes.AUTHORIZATION_STATUS} 
                        value={defaultValues.lAuthorization.autorizatie.status} 
                        register={{...register('lAuthorization.autorizatie.status', {required: ValidationMessages.REQUITED_MESSAGE})}}
                        error={!!errors?.lAuthorization?.autorizatie?.status}
                        helperText={errors?.lAuthorization?.autorizatie?.status ? errors.lAuthorization.autorizatie?.status.message : null}
                    />   
                </Grid>
                <Grid item xs={10}>
                </Grid>

                {/*row*/}
                <Grid item xs={4} style={{ display: "flex", alignItems: "center" }}>
                    {defaultValues.lAuthorization.pdfCertificateKey && (              
                        <React.Fragment key="certificateDownload">
                            <Link onClick={() => downloadCertificateDoc(defaultValues.lAuthorization.pdfCertificateKey)}>Download <FileDownloadIcon /></Link>
                        </React.Fragment>
                    )}
                </Grid>
                <Grid item xs={8}>
                    <label htmlFor="upload-certificate">
                        <input
                        type="file" accept="application/pdf"
                            id="upload-certificate"
                            name="upload-certificate"
                            style={{ display: 'none' }}
                            onChange={(event) => {
                                uploadCertificate(event.target.files[0]);
                            }}
                        />
                        <Box sx={{ m: 1, position: 'relative' }}>
                            <Button color="primary" variant="contained" component="span" disabled={isUploadingData}>
                                Incarca
                            </Button> (.pdf)
                            {isUploadingData && (
                                <CircularProgress 
                                    size={25} 
                                    sx={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        marginTop: '-12px',
                                        marginLeft: '-12px',
                                    }}
                                />
                            )}
                        </Box>
                    </label>
                </Grid>

            </Grid>
        </React.Fragment>
    );

}

